import { connect } from 'react-redux';
import ConsultaDebitos from './consultaDebitos';

export default connect()(ConsultaDebitos);
